import React from 'react';
import { useGlobalDialogContext } from 'App/components/Layouts/Dashboard/dialog/GlobalDialog';
import requestService from 'store/request/service';
import { ConfirmPurgeDocumentDialog } from './index';

export const ConfirmPurgeDocumentGlobalDialog = ({
  document,
  candidateFullName,
}: any) => {
  const { hideDialog } = useGlobalDialogContext();

  const [purgeDocumentRequest, { isLoading, isSuccess }] =
    requestService.endpoints.purgeDocumentRequest.useMutation();

  const handleDialogToggle = () => {
    hideDialog();
  };

  const handlePurge = () => {
    purgeDocumentRequest({
      documentRequestId: document.documentRequestId,
      candidateDocumentId: document.candidateDocumentId,
    });
  };

  return (
    <ConfirmPurgeDocumentDialog
      open={true}
      setOpen={() => {
        handleDialogToggle();
      }}
      isLoading={isLoading || isSuccess}
      isSuccess={isSuccess}
      candidateFullName={candidateFullName}
      documentType={document.documentType}
      onPurge={handlePurge}
    />
  );
};
